import { TabBodyWrapper } from 'components/Base/Tabs';
import WorkshopTasksTable from './WorkshopTasksTable';

type TasksTabProps = {
  workshopId: string;
};

const TasksTab = ({ workshopId }: TasksTabProps) => {
  if (!workshopId) {
    return (
      <TabBodyWrapper isEmpty>
        <div />
      </TabBodyWrapper>
    );
  }
  return <WorkshopTasksTable workshopId={workshopId} />;
};

export default TasksTab;
